module.exports = __webpack_public_path__ + "img/QuotationmarkCopy.d2879de9.png";